import { Card, Skeleton } from '@mui/material';

const IncomeChart = () => (
    <Card sx={{ p: 2 }}>
        {/* <Skeleton variant="text" /> */}
        <Skeleton variant="rectangular" width={'100%'} height={350} />
    </Card>
);

export default IncomeChart;
